module.exports = __webpack_public_path__ + "static/img/SketchPngc85d8e32530ff3cd98ab31e42818c4a52f0082b5288f53b0338c7662e4aea306.2816fc1f.png";